import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import OutageDetailViewModel from "viewModels/administration/outages/outageDetailViewModel";
import EditableDetailView from "../../common/editableDetailView";
import OutageForm from "./outageForm";

const OutageDetailView: ViewComponent<OutageDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<OutageForm vm={vm} />} />;
});

registerView(OutageDetailView, OutageDetailViewModel);
